import { IQuebecObstetricalFileFormPage } from "../IQuebecObstetricalFileFormPage";
import { ComplementaryExaminations } from "./ComplementaryExaminations";
import { PossibleDiscussions } from "./PossibleDiscussions";

class QuebecObstetricalFileFormPageThree implements IQuebecObstetricalFileFormPage {
    public Summary: string;
    public ComplementaryExaminations: ComplementaryExaminations;
    public PossibleDiscussions: PossibleDiscussions;

    constructor(fields?: Partial<QuebecObstetricalFileFormPageThree>) {
        Object.assign(this, fields);
        this.ComplementaryExaminations = new ComplementaryExaminations(fields?.ComplementaryExaminations);
        this.PossibleDiscussions = new PossibleDiscussions(fields?.PossibleDiscussions);
    }
}

export { QuebecObstetricalFileFormPageThree };
